import React, { memo, useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useNavigation, useNavigationState } from '@react-navigation/native';

import { BOTTOM_TABS_HEIGHT } from '@/components/TabBar';
import { Box } from '@/components/lib/components';
import { useBetslipStore } from '@/feature/betslip-pickem/hooks/use-betslip-store';

import { FantasyPickbar, PICK_BAR_ADDITIONAL_HEIGHT_FROM_MYSTERY, PICK_BAR_BOTTOM_DISTANCE } from './FantasyPickbar';

/**
 * Pickbar rendered inside the tab bar.
 * Reads navigation state directly to determine visibility.
 * Hides when navigating to player or event details sheets.
 */
export const LobbyPickbar = memo(() => {
    const hasPicks = useBetslipStore(state => state.betslip.length > 0);
    const [isSheetWithPickbarOpened, setIsSheetWithPickbarOpened] = useState(false);

    const navigation = useNavigation();

    const isOnPickbarTab = useNavigationState(state => {
        const activeRoute = state.routes[state.index];
        if (['Feed', 'FantasySearch'].includes(activeRoute.name)) {
            return true;
        }

        if (activeRoute.name === 'Lobby') {
            return (activeRoute.state?.routes?.[activeRoute.state.index ?? 0]?.name ?? 'LobbyScreen') === 'LobbyScreen';
        }
        return false;
    });

    useEffect(() => {
        // useNavigation() returns the root navigator inside the custom tab bar
        const unsubscribeRoot = navigation.addListener('state', state => {
            const routes = state.data.state?.routes ?? [];
            setIsSheetWithPickbarOpened(
                routes.some(r => r.name === 'PlayerProfileSheets' || r.name === 'FantasyEventsSheets')
            );
        });

        return unsubscribeRoot;
    }, [navigation]);

    const visible = hasPicks && !isSheetWithPickbarOpened && isOnPickbarTab;

    const insets = useSafeAreaInsets();
    const tabsOffset = BOTTOM_TABS_HEIGHT + insets.bottom;

    return (
        <Box pointerEvents={'box-none'} style={StyleSheet.absoluteFillObject}>
            <FantasyPickbar
                showContent={visible}
                hiddenPosition={-PICK_BAR_ADDITIONAL_HEIGHT_FROM_MYSTERY}
                visiblePosition={tabsOffset + PICK_BAR_BOTTOM_DISTANCE}
            />
        </Box>
    );
});
